/**
 * Number.isInteger() - Polyfill
 *
 * @ref https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
 */
'use strict';

var _Number$isInteger = require("@babel/runtime-corejs3/core-js-stable/number/is-integer");

(function () {
  Number.isInteger = _Number$isInteger || function (value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
  };
})();